"use client";

import { useState } from "react";
import { AuthEvent } from "@/features/Auth/AuthPopup/utils/constants";
import MiscProfileBox from "./MiscProfileBox";
import LazyLoaded from "@/components/LazyLoaded";
import { themeColors } from "@/utils/themeColors";
import { useCheckAuth } from "@/hooks/useCheckAuth";
import { UserDetails } from "@knowt/syncing/graphql/schema";
import { useCurrentUser } from "@knowt/syncing/hooks/user/useCurrentUser";
import dynamic from "next/dynamic";
import { isDarkColor } from "@knowt/syncing/utils/genericUtils";

const UserFollowingFollowersWithHookPopup = dynamic(
    () => import("@/components/userListCard/popups/UserFollowingFollowersPopups"),
    { ssr: false }
);

export const FollowersMiscProfileBox = ({ user: profileUser }: { user: UserDetails }) => {
    const { user: currentUser, userId } = useCurrentUser();
    const isOwner = userId === profileUser.ID;
    const user = isOwner ? currentUser : profileUser;
    const { checkAuth } = useCheckAuth();

    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <MiscProfileBox
                leftComponent={user?.numFollowers?.toLocaleString() || 0}
                style={{
                    height: "5rem",
                    color: "var(--color-profile-dynamic-text-color)",
                    border: `1px solid ${
                        user?.profileColor
                            ? isDarkColor(user?.profileColor)
                                ? themeColors.pureWhite
                                : themeColors.pureBlack
                            : themeColors.neutral1
                    }`,
                }}
                rightComponent={"followers"}
                onClick={e => {
                    e.stopPropagation();
                    checkAuth({
                        event: AuthEvent.SEE_FOLLOWERS_FOLLOWING,
                        onAuthSuccess: () => setIsOpen(true),
                    });
                }}
                sx={{ background: "unset" }}
            />

            {/* USER FOLLOWERS POPUP */}
            <LazyLoaded load={isOpen}>
                <UserFollowingFollowersWithHookPopup
                    userId={user?.ID as string}
                    isOpen={isOpen}
                    onClose={(e: React.MouseEvent) => {
                        e.stopPropagation();
                        setIsOpen(false);
                    }}
                    isForFollowing={false}
                    user={user}
                    isOwner={isOwner}
                />
            </LazyLoaded>
        </>
    );
};

export const FollowingMiscProfileBox = ({ user: profileUser }: { user: UserDetails }) => {
    const { user: currentUser, userId } = useCurrentUser();
    const isOwner = userId === profileUser.ID;
    const user = isOwner ? currentUser : profileUser;
    const { checkAuth } = useCheckAuth();

    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <MiscProfileBox
                leftComponent={user?.numFollowing?.toLocaleString() || 0}
                style={{
                    height: "5rem",
                    color: "var(--color-profile-dynamic-text-color)",
                    border: `1px solid ${
                        user?.profileColor
                            ? isDarkColor(user?.profileColor)
                                ? themeColors.pureWhite
                                : themeColors.pureBlack
                            : themeColors.neutral1
                    }`,
                }}
                rightComponent={"following"}
                onClick={e => {
                    e.stopPropagation();

                    checkAuth({
                        event: AuthEvent.SEE_FOLLOWERS_FOLLOWING,
                        onAuthSuccess: () => setIsOpen(true),
                    });
                }}
                sx={{ background: "unset" }}
            />

            {/* USER FOLLOWING POPUP */}
            <LazyLoaded load={isOpen}>
                <UserFollowingFollowersWithHookPopup
                    userId={user?.ID as string}
                    isOpen={isOpen}
                    onClose={(e: React.MouseEvent) => {
                        e.stopPropagation();
                        setIsOpen(false);
                    }}
                    isForFollowing={true}
                    user={user}
                    isOwner={isOwner}
                />
            </LazyLoaded>
        </>
    );
};
